import * as React from "react";

import { createFileRoute, Outlet, useNavigate, useRouterState } from "@tanstack/react-router";
import { z } from "zod";

import { ScheduleOverview, SCHEDULE_WEEK_COUNT } from "@/components/schedule/schedule-overview";

export const Route = createFileRoute("/_authed/call-times")({
  head: () => ({ meta: [{ title: "Call times" }] }),
  component: RouteComponent,
  validateSearch: z
    .object({
      week: z.coerce.number().int().min(1).max(SCHEDULE_WEEK_COUNT).optional(),
    })
    .passthrough(),
});

function RouteComponent() {
  const { week } = Route.useSearch();
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const navigate = useNavigate({ from: Route.fullPath });

  const handleWeekChange = React.useCallback(
    (nextWeek: number) => {
      navigate({ search: { week: nextWeek } });
    },
    [navigate],
  );

  const handleOpenDay = React.useCallback(
    (date: string, options?: { reviewChanges?: boolean }) => {
      navigate({
        to: "/call-times/$date",
        params: { date },
        search: options?.reviewChanges ? { reviewChanges: true } : {},
      });
    },
    [navigate],
  );

  if (pathname !== "/call-times") return <Outlet />;

  return (
    <ScheduleOverview weekParam={week} onWeekChange={handleWeekChange} onOpenDay={handleOpenDay} />
  );
}
